/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=4ebac4dd&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=4ebac4dd&lang=scss&scoped=true"

import exportComponent from "/Users/zhangmengxuan/Desktop/xinyan-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ebac4dd"]])

export default __exports__